/**
 * Enum of editor modes. Most forms default to edit mode.
 */
export enum EditorMode {
  Edit = 'edit',
  View = 'view'
}
